import { JSX, lazy, Suspense } from 'react';

import { QuillEditorProps } from './quill.types';

const QuillWrapped = lazy(() => import('./quill-wrapped'));

export default function Quill(props: QuillEditorProps): JSX.Element {
  return (
    <Suspense fallback="">
      <QuillWrapped {...props} />
    </Suspense>
  );
}
